













































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'
import {required} from "vuelidate/lib/validators";

import { CFMDTOVendor } from '@/scripts/services/ClientApiAuto'

@Component<VendorDialog>({
    components: {
    },
    validations() {
        return {
        vendor:{
            Name: {required}
        }
        }
    },
})
export default class VendorDialog extends CFMDialog {
    vendor: CFMDTOVendor = {Name: ''};

    selectedVendor :CFMDTOVendor = {Name: ''}

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.vendor.vendorGetById({id: <number>this.id});
        this.vendor = res.data;
      }
    
      if(this.isUpdate){
      if(this.vendor ){
          this.selectedVendor  = this.vendor;
      }
      }
      blockui.unBlockModal();
    }
    
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.vendor.Id,
        Name: this.vendor.Name,
        Email: this.vendor.Email
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.vendor.vendorSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
